import createHostComponent from '../../createHostComponent';
import defaults from './props/default';
var Form = createHostComponent('form', null, defaults);
export default Form;
